// Referral / Partner Pages (Tier 4)
const pages = [
  {
    slug: '/housing-after-rehab/',
    category: 'Referral / Partner Page', tier: 'Tier 4',
    name: 'Housing After Rehab',
    primaryKeyword: 'Housing After Rehab',
    keywords: ['where to live after rehab', 'sober housing after rehab', 'recovery housing after rehab'],
    title: 'Housing After Rehab in the Lehigh Valley, PA | PGSRH',
    description: 'Wondering where to live after rehab? PGSRH offers structured, sober recovery housing for men and women in the Lehigh Valley, PA. A stable next step after treatment.',
    blurb: 'A stable, sober place to live after completing rehab.',
    heroSubtitle: 'A stable, structured, sober place to live after completing rehab \u2014 so the progress you made continues at home.',
    intro: [
      'Leaving rehab is a hopeful moment and a risky one. Returning to an old environment too soon undoes a lot of progress. PGSRH provides structured recovery housing where men and women can land safely after treatment, in the Lehigh Valley.',
      'We are not a treatment provider \u2014 we are the next step after treatment: a substance-free home with routine, accountability, and peers who understand.',
    ],
    whoFor: [
      'People completing an inpatient or outpatient rehab program',
      'Individuals who don\u2019t have a safe, sober place to return to',
      'Treatment teams planning a discharge for a client',
      'Families arranging a stable next step for a loved one',
    ],
    sections: [
      { h: 'Why housing after rehab matters', p: [
        'The weeks after rehab are when structure matters most. A sober home surrounds people with accountability and support exactly when old routines and environments are most tempting.',
        'Living with peers who share the goal makes it far easier to keep the momentum from treatment going.',
      ] },
      { h: 'Coordinating a smooth transition', p: [
        'We work with treatment teams, case managers, and families to time a move-in around a discharge. The goal is no gap between finishing treatment and arriving somewhere stable.',
        'PGSRH provides housing and peer support \u2014 residents continue any clinical care with their own outside providers.',
      ] },
    ],
    faqs: [
      { q: 'Is this a continuation of my rehab program?', a: 'No. PGSRH is recovery housing, not treatment. It is a sober, structured place to live after rehab. Any clinical care continues with your own outside providers.' },
      { q: 'Can I move in right after discharge?', a: 'We try to coordinate move-in around your discharge so there is no gap. Contact PGSRH early to check availability and timing.' },
      { q: 'Can my treatment team refer me?', a: 'Yes. Treatment teams, case managers, and families can reach out on your behalf. See our referrals page for the process.' },
      { q: 'Is help with cost available after rehab?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/sober-housing-after-treatment/',
    category: 'Referral / Partner Page', tier: 'Tier 4',
    name: 'Sober Housing After Treatment',
    primaryKeyword: 'Sober Housing After Treatment',
    keywords: ['sober living after treatment', 'housing after treatment', 'recovery housing after treatment'],
    title: 'Sober Housing After Treatment | PGSRH Lehigh Valley, PA',
    description: 'PGSRH sober housing gives men and women a structured, substance-free home after completing treatment in the Lehigh Valley, PA. A supportive next step \u2014 not treatment.',
    blurb: 'Sober, structured housing for the step after treatment.',
    heroSubtitle: 'A structured, substance-free home for the step right after treatment \u2014 stability, routine, and peer support.',
    intro: [
      'Finishing treatment is an accomplishment, but the question of "where do I live now?" can be daunting. PGSRH sober housing gives men and women a supportive, substance-free home for the transition after treatment, in the Lehigh Valley.',
      'This is housing and community, not clinical care \u2014 a dependable place to live while you keep your recovery moving.',
    ],
    whoFor: [
      'People completing a treatment program of any kind',
      'Individuals who need a sober, structured home afterward',
      'Case managers and treatment teams planning next steps',
      'Families supporting a loved one after treatment',
    ],
    sections: [
      { h: 'A supportive bridge after treatment', p: [
        'Sober housing helps people carry the gains from treatment into everyday life. Living with peers, keeping a routine, and following house expectations reinforce the habits that treatment started.',
        'It is a bridge \u2014 stable footing between a program and independent living.',
      ] },
      { h: 'Working with treatment providers', p: [
        'We regularly coordinate with treatment centers and case managers to support referrals and smooth transitions. If you\u2019re a provider, we\u2019re glad to talk through placement.',
        'Residents continue clinical care with their own providers; PGSRH provides the home and community.',
      ] },
    ],
    faqs: [
      { q: 'Is sober housing after treatment the same as recovery housing?', a: 'Yes. It is structured, substance-free housing with peer support for the period after completing treatment.' },
      { q: 'Do you provide aftercare or therapy?', a: 'No. PGSRH provides housing and peer support, not clinical aftercare, therapy, or medical services.' },
      { q: 'Can a treatment center refer a client?', a: 'Yes. Providers, case managers, and families can contact us to arrange placement. See our referrals page.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/transitional-housing-after-rehab/',
    category: 'Referral / Partner Page', tier: 'Tier 4',
    name: 'Transitional Housing After Rehab',
    primaryKeyword: 'Transitional Housing After Rehab',
    keywords: ['transitional housing after treatment', 'transitional sober living after rehab'],
    title: 'Transitional Housing After Rehab | PGSRH Lehigh Valley, PA',
    description: 'PGSRH transitional housing gives men and women a structured, sober home to bridge rehab and independent living in the Lehigh Valley, PA. Supportive next step \u2014 not treatment.',
    blurb: 'Transitional, sober housing to bridge rehab and independent living.',
    heroSubtitle: 'Transitional, structured housing to bridge the gap between rehab and living independently.',
    intro: [
      'For many people, the jump from rehab straight to independent living is too big. Transitional housing fills that gap with a structured, sober home. PGSRH offers transitional recovery housing for men and women in the Lehigh Valley.',
      'It gives residents time to rebuild routine, employment, and stability with support before living fully on their own.',
    ],
    whoFor: [
      'People leaving rehab who aren\u2019t ready for independent living',
      'Individuals who need time to rebuild stability with support',
      'Treatment teams planning a step-down after a program',
      'Families arranging a transitional step for a loved one',
    ],
    sections: [
      { h: 'A true step-down', p: [
        'Transitional housing lets people practice everyday life \u2014 work, meetings, responsibilities \u2014 while still living somewhere structured and sober. It is a gradual, supported step toward independence.',
        'Length of stay is flexible; the goal is confidence, not a rushed exit.',
      ] },
      { h: 'Part of our transitional network', p: [
        'This page connects to our broader transitional recovery housing hub and our after-rehab and after-detox pages, so you can see the full path from treatment to independent living.',
        'PGSRH provides housing and peer support; clinical care stays with a resident\u2019s own providers.',
      ] },
    ],
    faqs: [
      { q: 'How is transitional housing different from regular recovery housing?', a: 'It\u2019s the same kind of structured, sober home, framed specifically for the step down from rehab toward independent living.' },
      { q: 'How long is the transition?', a: 'Length of stay is flexible and based on individual progress and needs.' },
      { q: 'Can my treatment program refer me?', a: 'Yes. Providers, case managers, and families can reach out to coordinate a transition.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/recovery-housing-after-detox/',
    category: 'Referral / Partner Page', tier: 'Tier 4',
    name: 'Recovery Housing After Detox',
    primaryKeyword: 'Recovery Housing After Detox',
    keywords: ['housing after detox', 'sober living after detox', 'where to go after detox'],
    title: 'Recovery Housing After Detox | PGSRH Lehigh Valley, PA',
    description: 'Not sure where to go after detox? PGSRH offers structured, sober recovery housing for men and women in the Lehigh Valley, PA \u2014 a stable next step. Housing, not detox.',
    blurb: 'A stable, sober place to live after completing detox.',
    heroSubtitle: 'A safe, structured, sober home for the step right after detox \u2014 so recovery has a stable place to continue.',
    intro: [
      'Detox is only the beginning, and going home to an unstable environment right after can be dangerous. PGSRH provides recovery housing where men and women can land after completing detox elsewhere, in the Lehigh Valley.',
      'We do not provide medical detox \u2014 we provide the safe, sober housing that supports the next stage of recovery once detox is complete.',
    ],
    whoFor: [
      'People who have completed detox and need a sober place to live',
      'Individuals without a safe, stable environment to return to',
      'Detox and treatment teams planning a next step',
      'Families arranging housing for a loved one after detox',
    ],
    sections: [
      { h: 'The stage right after detox', p: [
        'The days and weeks after detox are fragile. A substance-free home with structure, routine, and peers dramatically improves the odds of staying on track.',
        'Our homes provide that stability so the work started in detox can continue.',
      ] },
      { h: 'Housing \u2014 not medical detox', p: [
        'To be clear: PGSRH does not provide detox or medical services. We provide recovery housing for after detox is complete. Any clinical care continues with a resident\u2019s own providers.',
        'We coordinate with detox and treatment teams to make the transition smooth.',
      ] },
    ],
    faqs: [
      { q: 'Does PGSRH provide detox?', a: 'No. PGSRH does not provide detox or any medical services. We provide sober recovery housing for after detox is completed elsewhere.' },
      { q: 'Can I move in right after detox?', a: 'We try to coordinate move-in with your detox or treatment team. Contact PGSRH early to check availability and timing.' },
      { q: 'Who can refer me?', a: 'Detox teams, treatment centers, case managers, and families can all reach out on your behalf.' },
      { q: 'Is help with cost available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/recovery-housing-after-treatment/',
    category: 'Referral / Partner Page', tier: 'Tier 4',
    name: 'Recovery Housing After Treatment',
    primaryKeyword: 'Recovery Housing After Treatment',
    keywords: ['recovery housing after rehab', 'sober housing after treatment', 'recovery residence after treatment'],
    title: 'Recovery Housing After Treatment | PGSRH Lehigh Valley, PA',
    description: 'PGSRH recovery housing gives men and women a structured, sober home after completing treatment in the Lehigh Valley, PA. A supportive next step \u2014 not treatment itself.',
    blurb: 'Structured, sober housing for life after treatment.',
    heroSubtitle: 'A structured, sober home for life after treatment \u2014 stability and community as you carry your recovery forward.',
    intro: [
      'After treatment, the everyday environment you return to shapes your recovery. PGSRH recovery housing gives men and women a stable, substance-free home for the period after treatment, in the Lehigh Valley.',
      'It is a supportive next step, not treatment itself \u2014 a place to live with routine, accountability, and peers who understand.',
    ],
    whoFor: [
      'People who have completed a treatment program',
      'Individuals who need a sober, structured home afterward',
      'Treatment teams and case managers arranging next steps',
      'Families supporting a loved one after treatment',
    ],
    sections: [
      { h: 'Protecting the gains from treatment', p: [
        'Recovery housing after treatment surrounds people with structure and support during the vulnerable early stage. Peers, routine, and clear expectations help protect the progress made in a program.',
        'This is one of the highest-impact steps a person can take right after treatment.',
      ] },
      { h: 'Referral-friendly and coordinated', p: [
        'We regularly coordinate with treatment providers and case managers on referrals and timing. If you\u2019re a provider, we\u2019re glad to discuss placement.',
        'PGSRH provides the home and community; clinical care stays with a resident\u2019s own providers.',
      ] },
    ],
    faqs: [
      { q: 'Is recovery housing part of my treatment?', a: 'No. It is a sober, structured place to live after treatment. PGSRH does not provide clinical or medical services.' },
      { q: 'How soon after treatment should I move in?', a: 'As soon as possible, ideally with no gap. Contact PGSRH early to coordinate around your discharge.' },
      { q: 'Can my provider refer me?', a: 'Yes. Providers, case managers, and families can reach out to arrange placement.' },
      { q: 'Is funding available after treatment?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply.' },
    ],
    funding: true,
  },
  {
    slug: '/court-approved-recovery-housing/',
    category: 'Referral / Partner Page', tier: 'Tier 4',
    name: 'Court Approved Recovery Housing',
    primaryKeyword: 'Court Approved Recovery Housing',
    keywords: ['court approved sober living', 'court ordered sober living', 'court approved recovery house'],
    title: 'Court-Involved Recovery Housing | PGSRH Lehigh Valley, PA',
    description: 'PGSRH offers structured, sober recovery housing for men and women in the Lehigh Valley, PA who are navigating court or referral requirements. We can discuss housing and referral needs.',
    blurb: 'Recovery housing and referral discussions for court-involved individuals.',
    heroSubtitle: 'Structured, sober recovery housing for people navigating court or referral requirements \u2014 let\u2019s talk through your housing needs.',
    intro: [
      'People involved with the court system often need a stable, sober place to live as part of their recovery and their next steps. PGSRH provides structured recovery housing for men and women in the Lehigh Valley and can discuss housing options and referral needs with you or your representative.',
      'We are careful not to make legal promises. We cannot guarantee court approval or any legal outcome \u2014 but we can explain our housing and talk through how it may fit a court or referral requirement.',
    ],
    whoFor: [
      'Individuals navigating court or diversion requirements who need sober housing',
      'Attorneys, case managers, and referral partners exploring options',
      'People who need a stable address and structured environment',
      'Families supporting a loved one through a court-involved process',
    ],
    sections: [
      { h: 'What we can and cannot say', p: [
        'PGSRH can discuss housing options and referral needs, and describe our structured, substance-free homes. What we cannot do is guarantee court approval, acceptance of our housing by any court, or any specific legal outcome \u2014 those decisions rest with the court.',
        'If your requirement calls for specific documentation, contact us and we\u2019ll explain what we can reasonably provide.',
      ] },
      { h: 'A stable, structured environment', p: [
        'Our homes offer routine, accountability, and a sober living environment \u2014 the kind of stability often sought during a court-involved process.',
        'We\u2019re happy to talk with you, an attorney, or a case manager about whether our housing fits the situation.',
      ] },
    ],
    faqs: [
      { q: 'Can PGSRH guarantee the court will approve this housing?', a: 'No. We cannot guarantee court approval or any legal outcome. We can discuss our housing and referral needs; approval decisions rest with the court.' },
      { q: 'Do you provide legal or clinical services?', a: 'No. PGSRH provides recovery housing only \u2014 not legal, clinical, or medical services.' },
      { q: 'Can my attorney or case manager contact you?', a: 'Yes. Attorneys, case managers, and referral partners are welcome to reach out to discuss housing options.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply; nothing is guaranteed.' },
    ],
    funding: true,
  },
  {
    slug: '/recovery-housing-for-probation/',
    category: 'Referral / Partner Page', tier: 'Tier 4',
    name: 'Recovery Housing for Probation',
    primaryKeyword: 'Recovery Housing for Probation',
    keywords: ['sober living for probation', 'recovery housing probation', 'probation approved sober living'],
    title: 'Recovery Housing for Probation | PGSRH Lehigh Valley, PA',
    description: 'PGSRH offers structured, sober recovery housing for men and women in the Lehigh Valley, PA who are on probation. We can discuss housing options and referral needs \u2014 no legal promises.',
    blurb: 'Sober housing and referral discussions for people on probation.',
    heroSubtitle: 'Structured, sober recovery housing for people on probation \u2014 we can discuss housing options and referral needs.',
    intro: [
      'A stable, sober place to live can be an important part of meeting probation goals and supporting recovery. PGSRH provides structured recovery housing for men and women in the Lehigh Valley and can discuss housing and referral needs with you or your probation contact.',
      'We do not make legal promises. We cannot guarantee that our housing satisfies any specific probation requirement \u2014 but we can explain our homes and talk through how they may fit.',
    ],
    whoFor: [
      'People on probation who need a stable, sober place to live',
      'Probation officers and referral partners exploring housing options',
      'Individuals who benefit from structure and accountability',
      'Families supporting a loved one on probation',
    ],
    sections: [
      { h: 'Careful, honest language', p: [
        'PGSRH can discuss housing options and referral needs and describe our structured environment. We cannot guarantee approval by any probation office or any legal outcome \u2014 those decisions rest with the supervising authority.',
        'If specific documentation is needed, contact us and we\u2019ll explain what we can reasonably provide.',
      ] },
      { h: 'Structure that supports accountability', p: [
        'Our homes provide routine, house expectations, and a sober environment \u2014 stability that can support someone working through a probation period.',
        'Probation officers, case managers, and families are welcome to reach out to discuss options.',
      ] },
    ],
    faqs: [
      { q: 'Is this "probation approved" housing?', a: 'We can discuss housing options and referral needs, but we cannot guarantee approval by any probation office or any legal outcome. Those decisions rest with the supervising authority.' },
      { q: 'Do you provide legal services or supervision?', a: 'No. PGSRH provides recovery housing only \u2014 not legal services, supervision, or clinical care.' },
      { q: 'Can a probation officer contact you?', a: 'Yes. Probation officers, case managers, and families are welcome to reach out to discuss housing options.' },
      { q: 'Is funding available?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply; nothing is guaranteed.' },
    ],
    funding: true,
  },
  {
    slug: '/recovery-housing-referrals/',
    category: 'Referral / Partner Page', tier: 'Tier 4',
    name: 'Recovery Housing Referrals',
    primaryKeyword: 'Recovery Housing Referrals',
    keywords: ['recovery housing referral', 'sober living referral', 'recovery residence referrals'],
    title: 'Recovery Housing Referrals | PGSRH Lehigh Valley, PA',
    description: 'Refer a client to PGSRH recovery housing in the Lehigh Valley, PA. We work with treatment centers, case managers, probation officers, and families. Contact us to start.',
    blurb: 'For treatment centers, case managers, and families making referrals.',
    heroSubtitle: 'A simple, responsive referral process for treatment centers, case managers, probation officers, and families.',
    intro: [
      'Referral partners are essential to getting people into stable recovery housing at the right moment. PGSRH works with treatment centers, case managers, probation officers, and families to place men and women into our Lehigh Valley homes.',
      'This page explains how to make a referral and what to expect from us in return.',
    ],
    whoFor: [
      'Treatment centers planning client discharges',
      'Case managers and social workers arranging housing',
      'Probation officers and court-involved referral partners',
      'Families making a referral for a loved one',
    ],
    sections: [
      { h: 'How to refer someone', p: [
        'You can call us, submit our online application on a client\u2019s behalf, or reach out by email to start a conversation. Share the basics \u2014 who the person is, gender-specific housing needs, timing, and any relevant context \u2014 and we\u2019ll take it from there.',
        'We aim to respond promptly so timing lines up with a discharge or transition.',
      ] },
      { h: 'What partners can expect', p: [
        'We\u2019ll give you an honest read on current availability, explain what living in our homes involves, and coordinate move-in timing. Clear communication keeps transitions smooth for everyone.',
        'PGSRH provides housing and peer support; clients continue clinical care with their own providers.',
      ] },
    ],
    faqs: [
      { q: 'How do I make a referral?', a: 'Call PGSRH, submit our online application on the client\u2019s behalf, or email us. Share the key details and we\u2019ll follow up promptly.' },
      { q: 'How quickly do you respond to referrals?', a: 'We aim to respond promptly so timing aligns with a discharge or transition. Contact us to confirm current availability.' },
      { q: 'What information should I include?', a: 'The person\u2019s name and contact, gender-specific housing needs, desired timing, and any relevant context for placement.' },
      { q: 'Can funding be arranged through a referral?', a: 'Funding or scholarship options may be available depending on eligibility and availability. Ask PGSRH what may apply; approval is not guaranteed.' },
    ],
    funding: true,
  },
];

export default pages;
